import React from 'react';
import { ImageCouldFromRemoteServer as Image } from '@/components/images'
import { useRouter } from '@/navigation';
import { useTranslations } from 'next-intl';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';
import { ViewEnum } from '@/types';
import { useAppearanceStore } from '@/store/appearance';
import { SportIcon } from '@/components/icons/svg-icons';
import { useSiteStore } from '@/store/site';
import { useAccountInfo } from '@/hooks/query/account';
interface BetbyEsoccerSliderProps {
	onClose: () => void;
}

export const BetbyEsoccerSlider: React.FC<BetbyEsoccerSliderProps> = ({
	onClose,
}) => {
	const router = useRouter();
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const view = useAppearanceStore(state => state.view);
	const [setCurrentPage] = useSiteStore(state => [state.setCurrentPage]);

	const handleClickButton = async () => {
		setKafkaNormal({
			note: KafkaNote.Betby_eSoccer,
			type: view == ViewEnum.mars ? 1 : 2,
			action: 6,
		});
		setCurrentPage('lbl_VirtualSport');
		router.push('/sports/116');
		onClose();
	};

	return (
		<div className="betby-esoccer-modal">
			<Image
				src="/images/promotion-activity-modal/betby-esoccer-slider/promo-bg.png"
				alt=""
				width="288"
				height="360"
				className="betby-esoccer-modal__bg"
				isGalaxyFolder={true}
			/>
			<div className="betby-esoccer-modal__content">
				<div className="betby-esoccer-modal__title">
					{t('lbl_BetbyEsoccerPopup02')}
				</div>
				<div className="betby-esoccer-modal__content-frame">
					<Image
						src="/images/promotion-activity-modal/betby-esoccer-slider/content-bg.png"
						alt=""
						width="264"
						height="96"
						className="betby-esoccer-modal__content-bg"
						isGalaxyFolder={true}
					/>

					<div className="betby-esoccer-modal__content-wrapper">
						<div className="betby-esoccer-modal__sports">
							<div className="betby-esoccer-modal__sports-item">
								<div className="betby-esoccer-modal__tag">{t('lbl_BetbyEsoccerPopup01')}</div>
								<SportIcon sportId="116" isColorful={true} />
								<div className="betby-esoccer-modal__sports-name">{t('lbl_BetbyEsoccerPopup03')}</div>
							</div>
							<div className="betby-esoccer-modal__sports-item">
								<div className="betby-esoccer-modal__tag">{t('lbl_BetbyEsoccerPopup01')}</div>
								<SportIcon sportId="134" isColorful={true} />
								<div className="betby-esoccer-modal__sports-name">{t('lbl_NBA2K')}</div>
							</div>
						</div>
						<div className="betby-esoccer-modal__subTitle" data-storke={`${t('lbl_BetbyEsoccerPopup05')}・${t('lbl_BetbyEsoccerPopup06')}`}>
							{`${t('lbl_BetbyEsoccerPopup05')}・${t('lbl_BetbyEsoccerPopup06')}`}
						</div>
					</div>
				</div>
			</div>
			<div className="betby-esoccer-modal__footer">
				{user?.LicenseeSiteSetting?.EnableBetbyEsoccer && (
					<button 
						className="betby-esoccer-modal__btn" 
						onClick={handleClickButton}
					>
						{t('lbl_BetbyEsoccerPopup07')}
					</button>
				)}
			</div>
		</div>
	);
};